@if (componentData.uid === 'Section5ImageComponent') {
  <app-homepage-image-section5
  [componentData]="componentData"></app-homepage-image-section5>
}

@if (componentData.uid === 'Section6ImageComponent') {
  <app-homepage-image-section6
  [componentData]="componentData"></app-homepage-image-section6>
}

@if (componentData.uid === 'Section7ImageComponent') {
  <app-homepage-image-section7
  [componentData]="componentData"></app-homepage-image-section7>
}

@if (componentData.uid === 'Section8ImageComponent') {
  <app-homepage-image-section8
  [componentData]="componentData"></app-homepage-image-section8>
}

@if (componentData.uid === 'Section9ImageComponent') {
  <app-homepage-image-section9
  [componentData]="componentData"></app-homepage-image-section9>
}

@if (componentData.uid === 'SGREFooterImageComponent') {
  <app-footer-image></app-footer-image>
}